<template>
    <div>
        <Collapse style="border-top:none;" accordion v-model="value3" simple>
            <Panel name="1">
                {{this.isjd?'解答要素':(this.iswsw?'判例要素':this.iscase?'案例要素':'文件要素')}}
                <div slot="content">
                    <Table :row-class-name="rowClassName" border ref="tableSelection" :columns="columns4" size="small" :data="data1" stripe></Table>
                </div>
            </Panel>
        </Collapse>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    name: 'DocumentPropsTable',
    data() {
        return {
            value3: [1],
            columns4: [],
            data1: [],
            isjd: false,
            iswsw: false,
            iscase: false,
        }
    },
    computed: {
        ...mapGetters(['sta'])
    },
    methods: {
        ...mapActions(['handleSetUserLogout', 'handleSetBookHistoryFiles', 'handleRemoveBookHistoryFiles']),
        rowClassName(row, index) {
          // console.log(index)
            if (index % 2 == 1) {
                return 'text-table-info-row3';
            }else{
              return 'text-table-info-row2';
            }
            
        },
        onSelect(arg) {

        },
        handleSelectAll(status) {
            this.$refs.tableSelection.selectAll(status);
        },
        showDeleted(sliders) {
            // var list=this.getSelected()
            // console.log(list)
            // var list=sliders
            // console.log(list)
        },
        getSelected() {
            return this.$refs.tableSelection.getSelection()
        },
        bindData(row, trow) {
            //console.log('bindData++++===============》')
            // console.log(trow)
            //如果是解答需要修改要素的描述字段
            if (trow && trow.jd) {
                this.isjd = trow.jd
                this.iswsw = trow.wsw
            }
            if (trow && trow.wsw) {
                this.iswsw = trow.wsw
            }
            if (trow && trow.case) {
                this.iscase = trow.case
            }

            this.columns4 = this.mockHeader()
            var mockTable = this.createTable(row)
            this.data1 = mockTable
        },
        mounted() {
            //this.handleSelectAll(true)

        },
        createTable(rows) {
            let da = []
            let items = rows
            for (var i = 0; i < items.length; i++) {
                da.push({
                    elementname: items[i].elementname,
                    elementtext: items[i].elementtext
                })
            }
            return da
        },
        link(value) {
            var selector = value; //value.srcElement
            //var text = value.srcElement.innerHTML.replace(/<\/?[^>]*>/g, '') //去掉所有的html标记
            var text = value.srcElement.innerText
            this.$emit('onLink', selector, '', text)
            //console.log(value.srcElement)
        },
        mockHeader() {
            var that = this
            //console.log(editorType)
            let arr = []
            let edithistory = [{
                    type: 'index',
                    width: 60,
                    align: 'center'
                },
                {
                    title: this.isjd ? '解答要素' : (this.iswsw ? '判例要素' : (this.iscase ? '案例要素' : '文件要素')),
                    width: 200,
                    key: 'elementname'
                },
                // {
                //   title: '内容',
                //   key: 'elementtext'
                // },
                {
                    title: '内容',
                    key: 'elementtext',
                    // width: 150,
                    align: 'center',
                    render: function(createElement, params) {
                        const row = params.row;
                        const text = row.elementtext;
                        return createElement('div', {}, [
                            // "查阅了",
                            createElement('div', {
                                domProps: {
                                    innerHTML: text, //'<item class="ls" id="112233">' + text + '</item>'
                                },
                                on: {
                                    'click': (value) => {
                                        that.link(value);
                                    }
                                }
                            }, ''),
                        ])
                    }

                }
                // {
                //   title: '删除',
                //   key: 'action',
                //   width: 150,
                //   align: 'center',
                //   render: (h, params) => {
                //   const row = params.row;
                //    // const fileid = row.fileid;
                //     return h('div', [h('Button', {
                //       props: {
                //         type: 'error',
                //         size: 'small',
                //         icon:'md-trash',
                //       },
                //       on: {
                //         click: () => {
                //           this.remove(row)
                //         }
                //       }
                //     }, '删除')]);
                //   }
                // }
            ]
            arr = edithistory
            return arr
        },

    }
}
</script>
<style>
.ls {
    /* text-decoration: underline;*/
    color: blue;
    cursor: Pointer;
}

.ivu-table .text-table-info-row3 td {
    background: #F5F6FA !important;
}

.ivu-table .text-table-info-row2 td {
    background: white;
}

.ivu-table-header table thead tr th{
    background: #F5F6FA;
}
</style>